module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl1-75.a0dacf52.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl1-75.png
// module id = 3329
// module chunks = 11